import React, { Fragment, useState, useMemo } from 'react'
import useStyles from './styles'
import { Box, IconButton, useMediaQuery } from '@material-ui/core'
import Sponsor from './Sponsor'
import Carousel from '@brainhubeu/react-carousel'
import LeftArrowIcon from '@material-ui/icons/KeyboardArrowLeft'
import RightArrowIcon from '@material-ui/icons/KeyboardArrowRight'
import AutoSizer from 'react-virtualized-auto-sizer'
import { useSelector } from 'react-redux'
import classnames from 'clsx'

const paddingOffset = 48
const slideSize = 240

const Sponsors = ({ sponsors }) => {
  const classes = useStyles()
  const orientation = useSelector(state => state.window.orientation)

  const isPhoneLandscape = useMediaQuery(
    '(max-width: 1023px) and (orientation: landscape)'
  )

  const [value, setValue] = useState()

  const slidesPerPage = useMemo(() => {
    return Math.floor((window.innerWidth - paddingOffset) / slideSize)
  }, [window.innerWidth])

  if (isPhoneLandscape) {
    return null
  } else {
    return (
      <Box className={classnames(classes.sponsors, classes[orientation])}>
        <div style={{ flex: '1 1 auto', height: '100%' }}>
          <AutoSizer style={{ backgroundColor: 'red' }}>
            {({ height, width }) => (
              <Fragment>
                {sponsors && (
                  <Box
                    display="flex"
                    alignItems="center"
                    style={{
                      height,
                      width
                    }}
                  >
                    <Carousel
                      addArrowClickHandler
                      autoPlay={15000}
                      animationSpeed={2000}
                      infinite
                      slidesPerPage={slidesPerPage}
                      slidesPerScroll={slidesPerPage}
                      arrowLeft={
                        <IconButton className={classes.arrowButton}>
                          <LeftArrowIcon />
                        </IconButton>
                      }
                      arrowRight={
                        <IconButton className={classes.arrowButton}>
                          <RightArrowIcon />
                        </IconButton>
                      }
                    >
                      {[...sponsors].map((sponsor, i) => (
                        <Sponsor
                          key={i}
                          sponsor={sponsor}
                          height={height}
                          width={slideSize}
                        />
                      ))}
                    </Carousel>
                  </Box>
                )}
              </Fragment>
            )}
          </AutoSizer>
        </div>
      </Box>
    )
  }
}

export default Sponsors



// WEBPACK FOOTER //
// ./src/components/Sponsors/index.jsx